import { iconBank } from './iconBank';

const FALLBACK_GRADIENT = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';

/**
 * Resolves the icon tile background for a company value.
 * Prefer a stored iconBackground; otherwise use the icon bank default for the
 * selected icon (same rule as AddEditValueModal preview).
 */
export const resolveCompanyValueIconBackground = (
    icon?: string | null,
    iconBackground?: string | null,
): string => {
    const stored = iconBackground?.trim();
    if (stored) {
        return stored;
    }

    const iconMeta = iconBank.find((entry) => entry.id === (icon || 'heart'));
    return iconMeta?.bg ?? FALLBACK_GRADIENT;
};
